import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { logger } from '../utils/logger';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cachedFilters = null;
let cacheTimestamp = 0;
const CACHE_TTL = 60_000;

export const useShopFilters = () => {
  const [filters, setFilters] = useState(cachedFilters || { brands: [], products: [] });
  const [loading, setLoading] = useState(!cachedFilters);

  const fetchFilters = useCallback(async (force = false) => {
    const now = Date.now();
    if (!force && cachedFilters && now - cacheTimestamp < CACHE_TTL) {
      setFilters(cachedFilters);
      setLoading(false);
      return;
    }
    try {
      const res = await axios.get(`${API}/shop-filters`);
      cachedFilters = res.data;
      cacheTimestamp = Date.now();
      setFilters(res.data);
    } catch (error) {
      logger.error('Failed to fetch shop filters:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchFilters(); }, [fetchFilters]);

  return { ...filters, loading, refetch: () => fetchFilters(true) };
};
